// Initialise lenis smooth scroll
import initScroll from './utils/lenis';

initScroll();

// Import utils and components
import initLoadIn from './utils/load-in';
import initSplash from './components/splash';
import initHero from './components/hero';
import initPinned from './components/pinned';
import initMap from './components/map';
import initCarousel from './components/carousel';

const splashEl = document.querySelector('.js-splash');

if(splashEl) {
    initSplash(splashEl);
}

const heroEl = document.querySelector('.js-hero');

if(heroEl) {
    initHero(heroEl);
}

const mapEl = document.querySelector('.js-map');

if(mapEl) {
    initMap(mapEl);
}

const pinnedEls = document.querySelectorAll('.js-pinned');

if(pinnedEls) {
    initPinned(pinnedEls);
}

const loadInEls = document.querySelectorAll('.js-load-in');

if(loadInEls && loadInEls.length > 0) {
    initLoadIn(loadInEls);
}

const carouselWrap = document.querySelector('.js-carousel-wrap');

if(carouselWrap) {
    initCarousel(carouselWrap);
}

window.menuActive = false;
const menuToggle = document.querySelector('.js-menu-toggle');

menuToggle.addEventListener('click', (event) => {
    event.preventDefault();

    window.menuActive = !window.menuActive;

    if (window.menuActive) {
        document.body.classList.add('menu-open');
    } else {
        document.body.classList.remove('menu-open');
    }
});
